import React, { useEffect, useState } from 'react';
import config from '../config';

const SpecialOfferModal = () => {
  const [offer, setOffer] = useState(null);

  useEffect(() => {
    fetch('/offers.json') // 👈 if offers.json is in /public
      .then((res) => res.json())
      .then((data) => {
        const popupOffer = data.find(
          (o) => o.visible && o.type === 'popup' && !isDismissed(o.id)
        );
        if (popupOffer) setOffer(popupOffer);
      })
      .catch((err) => console.error('Failed to load offer:', err));
  }, []);

  const isDismissed = (id) =>
    sessionStorage.getItem(`dismiss_offer_${id}`) === 'true';

  const dismiss = () => {
    if (offer?.dismissible) {
      sessionStorage.setItem(`dismiss_offer_${offer.id}`, 'true');
    }
    setOffer(null);
  };

  if (!offer) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center px-4 md:px-0">
      <div
        className={`relative w-full max-w-md bg-white rounded-lg p-6 shadow-lg mx-auto ${
          offer.bgColor || ''
        } ${offer.textColor || ''}`}
      >
        {/* Close Button */}
        <button
          onClick={dismiss}
          className="absolute top-2 right-3 text-xl font-bold text-gray-400 hover:text-gray-600"
          aria-label="Close"
        >
          ✕
        </button>

        {/* Offer Content */}
        <h2 className="text-lg font-semibold mb-4 text-center">
          🎁 Special Offer
        </h2>
        <p className="text-sm text-center mb-6">{offer.message}</p>

        {/* Auth Buttons */}
        <div className="flex justify-center gap-4">
          <button
            onClick={() => window.open(config.signInUrl, '_blank')}
            className="bg-orange-100 text-gray-800 font-bold px-5 py-2 rounded-full hover:bg-orange-200 transition"
          >
            Login
          </button>
          <button
            onClick={() => window.open(config.signUpUrl, '_blank')}
            className="bg-orange-100 text-gray-800 font-bold px-5 py-2 rounded-full hover:bg-orange-200 transition"
          >
            Signup
          </button>
        </div>
      </div>
    </div>
  );
};

export default SpecialOfferModal;
